import type { ReactNode } from "react";

import { Card, CardContent, CardHeader } from "@/shared/ui/card";

interface OnboardingFrameProps {
  children: ReactNode;
  eyebrow?: string;
}

export function OnboardingFrame({
  children,
  eyebrow = "Mobile baseball scorekeeper",
}: OnboardingFrameProps) {
  return (
    <main className="flex min-h-[100svh] items-center justify-center px-[max(1rem,var(--safe-left))] py-[calc(1.5rem+var(--safe-top))] pr-[max(1rem,var(--safe-right))] pb-[calc(1.5rem+var(--safe-bottom))]">
      <div className="w-full max-w-md">
        <div className="mb-3 px-1">
          <div className="font-mono text-xs font-bold tracking-[0.18em] text-primary uppercase">
            Trash Pandas
          </div>
          <div className="text-xs text-foreground-muted">{eyebrow}</div>
        </div>
        <Card className="overflow-hidden border-border/90 bg-surface/95">
          <div className="h-1 bg-primary" />
          {children}
        </Card>
      </div>
    </main>
  );
}

interface OnboardingHeadingProps {
  title: string;
  description?: ReactNode;
}

export function OnboardingHeading({
  title,
  description,
}: OnboardingHeadingProps) {
  return (
    <CardHeader className="gap-2">
      <h1 className="m-0 font-mono text-xl font-bold tracking-[0.08em] uppercase">
        {title}
      </h1>
      {description ? (
        <p className="m-0 text-sm leading-relaxed text-foreground-muted">
          {description}
        </p>
      ) : null}
    </CardHeader>
  );
}

export function OnboardingContent({ children }: { children: ReactNode }) {
  return <CardContent className="grid gap-3">{children}</CardContent>;
}
